import React from 'react';
import LogOfflineInteractionModal from './LogOfflineInteractionModal';

function MentorMenteesLogOfflineInteraction() {
  return (
    <div className="card border-0 shadow-sm rounded-3 p-3 bg-white mb-3">
              <div className="d-flex flex-wrap align-items-center gap-3">
                <i className="bi bi-card-checklist bg-info bg-opacity-10 text-info rounded-3 p-3 fs-4"></i>
                <div className="flex-grow-1">
                  <h6 className="fw-bold mb-1 text-dark">Had an interaction outside the platform?</h6>
                  <p className="text-secondary small mb-0">Log a call, campus visit, or message — it counts toward your mentees' programme milestones.</p>
                </div>
                
                <LogOfflineInteractionModal/>
              </div>
            </div>
  )
}

export default MentorMenteesLogOfflineInteraction;